import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../../../assests/css/admin/AdminStoreSetting/AdminStoreSetting.css';
import AppContext from '../../../../context/AppContext';

const baseUrl = "http://127.0.0.1:8000/api";

const TABS = {
  'store-profile': {
    label: '🏪 Store Profile',
    title: 'Basic Information',
    editTitle: 'Edit Store Profile',
    editDesc: "Update your store's public identity and internal business information.",
    fields: [
      { key: 'storeName', label: 'Store Name', type: 'text' },
      { key: 'legalName', label: 'Legal Business Name', type: 'text' },
      { key: 'category', label: 'Store Category', type: 'text' },
      { key: 'supportPhone', label: 'Support Phone', type: 'text' },
      { key: 'supportEmail', label: 'Support Email', type: 'email', fullWidth: true, hint: 'Customers will use this address if they have questions about their orders.' }
    ]
  },
  shipping: {
    label: '🚚 Shipping & Delivery',
    title: 'Shipping & Delivery',
    editTitle: 'Edit Shipping & Delivery',
    editDesc: "Update your store's shipping rates and delivery estimates.",
    fields: [
      { key: 'freeShippingThreshold', label: 'Free Shipping Threshold (PKR)', type: 'number', prefix: 'PKR ' },
      { key: 'standardShippingCost', label: 'Standard Shipping Cost (PKR)', type: 'number', prefix: 'PKR ' },
      { key: 'expressShippingCost', label: 'Express Shipping Cost (PKR)', type: 'number', prefix: 'PKR ' },
      { key: 'estimatedDelivery', label: 'Estimated Delivery Time', type: 'text', placeholder: 'e.g., 3-5 business days' }
    ]
  }
};

const AdminStoreSetting = () => {
  const [BaseUrl, setBaseUrl] = useState(AppContext);
  const [activeTab, setActiveTab] = useState('store-profile');
  const [isEditing, setIsEditing] = useState(false);
  const [settings, setSettings] = useState({});
  const [editForm, setEditForm] = useState({});

  useEffect(() => {
    axios.get(`${baseUrl}/admin/storeSetting/fetchSettings`)
      .then(res => setSettings(res.data.data || {}));
  }, []);

  const tab = TABS[activeTab];

  const handleSave = () => {
    axios.post(`${baseUrl}/admin/storeSetting/update`, editForm)
      .then(res => {
        setSettings(res.data.data);
        setIsEditing(false);
      });
  };

  return (
    <div className="admin-store-settings">
      <div className="settings-header">
        <h1>Store Settings</h1>
        <p>Configure your store's public identity and internal business information.</p>
      </div>

      <div className="settings-nav">
        {Object.entries(TABS).map(([key, t]) => (
          <button
            key={key}
            className={activeTab === key ? 'active' : ''}
            onClick={() => { setActiveTab(key); setIsEditing(false); }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {isEditing ? (
        <div className="settings-edit-page">
          <div className="edit-page-header">
            <h2>{tab.editTitle}</h2>
            <p>{tab.editDesc}</p>
          </div>

          <div className="edit-page-form">
            {tab.fields.map(f => (
              <div className="form-group" key={f.key}>
                <label>{f.label}</label>
                <input
                  type={f.type}
                  value={editForm[f.key] ?? ''}
                  placeholder={f.placeholder}
                  onChange={(e) => setEditForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                />
              </div>
            ))}
          </div>

          <div className="edit-page-actions">
            <button className="btn btn-secondary" onClick={() => setIsEditing(false)}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSave}>Save Changes</button>
          </div>
        </div>
      ) : (
        <div className="tab-content">
          <div className="settings-card">
            <div className="card-header">
              <h3>{tab.title}</h3>
              <button
                className="btn-edit"
                onClick={() => { setEditForm(settings); setIsEditing(true); }}
              >
                ✏️ Edit
              </button>
            </div>
            <div className="form-grid">
              {tab.fields.map(f => (
                <div className={`form-group ${f.fullWidth ? 'full-width' : ''}`} key={f.key}>
                  <label>{f.label}</label>
                  <input
                    type="text"
                    value={`${f.prefix || ''}${settings[f.key] ?? ''}`}
                    readOnly
                  />
                  {f.hint && <small>{f.hint}</small>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminStoreSetting;